var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      attrs: {
        href: "javascript:0;",
        "data-toggle": "popover",
        "data-trigger": _vm.getTrigger,
        "data-placement": "top",
        "data-html": "true",
        "data-content": _vm.getPriceText
      }
    },
    [_c("i", { staticClass: "fa fa-info-circle" })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }